import { filter, flatten, map } from 'lodash'

import computeLabelOccurenceOriginField from './compute-label-occurence-origin-field'

const computeDishHighlightsSources = dish => ({
  suggestionsWithWords: [
    ...filter(dish.mainIngredients, 'isSuggestedUsingParser'),
    ...filter(dish.choiceIngredients, 'isSuggestedUsingParser'),
    ...filter(dish.blacklistedIngredients, 'isSuggestedUsingParser'),

    ...flatten(
      map(dish.aiSuggestion?.diets?.suggestion, dietSuggestion =>
        flatten(
          map(dietSuggestion.occurrences, occurrence => ({
            ...occurrence,
            originField: computeLabelOccurenceOriginField(occurrence),
            matchType: 'labelOccurrence',
          })),
        ),
      ),
    ),

    ...flatten(
      map(dish.aiSuggestion?.allergens?.suggestion, allergenSuggestion =>
        flatten(
          map(allergenSuggestion.occurrences, occurrence => ({
            ...occurrence,
            originField: computeLabelOccurenceOriginField(occurrence),
            matchType: 'labelOccurrence',
          })),
        ),
      ),
    ),
  ],
  additionalIngredients: dish.additionalIngredients,
})

export default computeDishHighlightsSources
